module.exports = __webpack_public_path__ + "static/b2-17b2228020db996c1c7403fb755a236b.png";